/** The storefront's brand page: `/vouchers/{brand name}` on the country's site (name-based, R-05). */
export function storefrontBrandUrl(siteUrl: string, brandName: string) {
  return `${siteUrl.replace(/\/+$/, '')}/vouchers/${encodeURIComponent(brandName)}`;
}
